// src/pages/About.js
import React from "react";
import { Link } from "react-router-dom";

export default function About() {
  return (
    <div
      className="card"
      style={{
        maxWidth: "850px",
        margin: "0 auto",
        background: "var(--card)",
        color: "var(--text)",
        padding: "2.5rem",
        borderRadius: "18px",
        boxShadow: "0 8px 25px rgba(0,0,0,0.45)",
        lineHeight: 1.7,
      }}
    >

      {/* Back to App Button */}
      <div style={{ marginBottom: "2rem" }}>
        <Link
          to="/journal"
          style={{
            display: "inline-block",
            padding: "0.6rem 1.2rem",
            background: "var(--primary)",
            color: "white",
            borderRadius: "10px",
            textDecoration: "none",
            fontWeight: "bold",
            fontSize: "0.95rem",
          }}
        >
          Back to ReflectRise
        </Link>
      </div>

      <h1 style={{ color: "var(--primary)", marginBottom: "1rem" }}>
        About ReflectRise
      </h1>

      <p>
        <strong>ReflectRise</strong> is a personal growth and journaling
        platform built to help people reflect deeply, stay consistent, and
        create meaningful long term progress. It combines journaling,
        goal tracking, streaks, analytics, and mindful guidance into a clean,
        distraction free experience.
      </p>

      <h2 style={{ color: "var(--primary)", marginTop: "2rem" }}>
        Mission
      </h2>
      <p>
        To empower individuals to reflect, grow, and become the best version of
        themselves one entry, one goal, one insight at a time.
      </p>

      <h2 style={{ color: "var(--primary)", marginTop: "2rem" }}>
        Who Created ReflectRise?
      </h2>
      <p>
        ReflectRise is created and fully developed by{" "}
        <strong>Nadeem Bauker</strong>, Founder and Lead Developer.
      </p>
      <p>
        Every feature from journaling to analytics to premium themes is built
        with care, clarity, and a real focus on helping users grow.
      </p>

      <h2 style={{ color: "var(--primary)", marginTop: "2rem" }}>
        Contact
      </h2>
      <p>
        If you need support, have questions, or want to discuss opportunities:
      </p>
      <p>
        <strong>Email: </strong>
        <a
          href="mailto:reflectrise25@gmail.com"
          style={{ color: "var(--primary)" }}
        >
          reflectrise25@gmail.com
        </a>
      </p>

      <h2 style={{ color: "var(--primary)", marginTop: "2rem" }}>
        Ownership
      </h2>
      <p>
        ReflectRise is independently created, owned, and maintained by{" "}
        <strong>Nadeem Bauker</strong>.
      </p>

      <p style={{ marginTop: "2rem", opacity: 0.7, fontSize: "0.9rem" }}>
        © {new Date().getFullYear()} ReflectRise Created and Owned by Nadeem Bauker.
      </p>
    </div>
  );
}
